import { Divider, Drawer, Layout, Button, Modal } from "antd";
import styles from "./SecondModal.module.scss";
import { useHistory } from "react-router-dom";
import _ from "lodash";
import { actionType } from "store/dataReducer";
import { HeartOutlined, FolderOutlined } from "@ant-design/icons";
import Profile from "assets/icons/profile/Profile.svg";
import SignOut from "assets/icons/profile/Sign_out.svg";
import { useDataStore } from "store/DataStoreContext";
import { IoIosArrowForward } from "react-icons/io";
import { useState } from "react";
import useWindowSize from "hook/useWindowSize";
import iconLogoout from "assets/icons/profile/icon-log-out-cu.svg";

const SecondModal = ({
  props,
  data,
  onClose,
  handleOpenSeconModal,
  handleSignOut,
  goToProfile,
  type,
}) => {
  const {
    state: { educationType, filter },
    dispatch,
  } = useDataStore();
  const history = useHistory();
  const { width, height } = useWindowSize();

  const [openModalSignout, setOpenModalSignout] = useState(false);

  const handleGoToProfile = () => {
    goToProfile();
    onClose();
    handleOpenSeconModal();
  };

  const handleGoToMyExam = () => {
    history.push("/myExam");
    onClose();
    handleOpenSeconModal();
  };

  const handleGoToMyFavorite = () => {
    history.push("/myFavorite");
    onClose();
    handleOpenSeconModal();
  };

  const handleChangeFilterLevel = (value) => {
    dispatch({
      type: actionType.CHANGE_FILTER_LEVEL,
      payload: {
        id: value,
        name: _.get(_.find(educationType.data, { id: value }), "name"),
      },
    });
  };

  const handleOpenModal = (input) => {
    handleChangeFilterLevel(input);
    if (type === "Pretest") {
      history.push("/pretest");
      onClose();
      handleOpenSeconModal();
    } else {
      history.push("/bundle");
      onClose();
      handleOpenSeconModal();
    }
  };

  const handleActionSignout = () => {
    setOpenModalSignout(!openModalSignout);
  };

  return (
    <div>
      {data === "profile" ? (
        <div className={styles.action_container}>
          <div className={styles.user_detail} onClick={handleGoToMyExam}>
            <FolderOutlined style={{ marginRight: "1rem" }} />
            ข้อสอบของฉัน
          </div>
          <div className={styles.user_detail} onClick={handleGoToMyFavorite}>
            <HeartOutlined style={{ marginRight: "1rem" }} />
            รายการที่ชอบ
          </div>
          <div className={styles.user_detail} onClick={handleGoToProfile}>
            <img src={Profile} alt="icon" />
            <div className={styles.detail_text}>ข้อมูลผู้ใช้งาน</div>
          </div>
          <div className={styles.user_detail} onClick={handleActionSignout}>
            <img src={SignOut} alt="icon" />
            <div className={styles.detail_text}>ออกจากระบบ</div>
          </div>
        </div>
      ) : (
        <div className={styles.level_con}>
          {_.map(educationType.data, (level) => {
            return (
              <div className={styles.level}>
                <div>{level.name}</div>
                <div onClick={() => handleOpenModal(level.id)}>
                  <IoIosArrowForward />
                </div>
              </div>
            );
          })}
        </div>
      )}
      {openModalSignout && (
        <div
          className={styles.sign_out}
          style={{ width: width, height: height }}
        >
          <div
            className={styles.container}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                backgroundColor: "#fde8f1",
                width: "100px",
                height: "100px",
                borderRadius: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "3rem",
              }}
            >
              <img
                src={iconLogoout}
                alt="iconLogoout"
                style={{ width: "50px" }}
              />
            </div>
            <div
              style={{
                marginTop: "3rem",
                fontSize: "1.5rem",
                fontWeight: "bold",
              }}
            >
              ออกจากระบบ
            </div>
            <div
              style={{
                marginTop: "2rem",
                marginBottom: ".75rem",
              }}
            >
              คุณต้องการออกจะระบบหรือไม่?
            </div>
          </div>
          <div className={styles.act_btn}>
            <Button
              type="primary"
              onClick={handleSignOut}
              style={{ width: "100%", maxWidth: "370px", marginBottom: "1rem" }}
            >
              ยืนยัน
            </Button>
            <Button
              style={{ width: "100%", maxWidth: "370px" }}
              onClick={handleActionSignout}
            >
              ยกเลิก
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SecondModal;
